export enum KycStatesEnumeration {
  BIZUM = 'BIZUM', // Bizum
  LANDING = 'LANDING', // Choose method
  METHOD = 'METHOD', // Account check and video call
}
